import type { MapMarker, MapTrack } from "@/components/map/types";
import type { MediaForPicture } from "@/lib/media-shared";

/** Merkliste im Browser (localStorage). Technisch notwendig für die angeforderte Funktion, daher ohne Einwilligung. */
export const BOOKMARK_KINDS = {
  place: { label: "Ort", plural: "Orte", path: "/orte/" },
  route: { label: "Route", plural: "Routen", path: "/routen/" },
  post: { label: "Beitrag", plural: "Beiträge", path: "/" },
} as const;
export type BookmarkKind = keyof typeof BOOKMARK_KINDS;
export const BOOKMARK_KIND_KEYS = Object.keys(BOOKMARK_KINDS) as BookmarkKind[];
export const MAX_BOOKMARKS = 100;

export type Bookmark = { k: BookmarkKind; s: string; t: string };
export const bookmarkKey = (b: { k: BookmarkKind; s: string }) => `${b.k}:${b.s}`;
export const bookmarkHref = (b: { k: BookmarkKind; s: string }) => BOOKMARK_KINDS[b.k].path + b.s;

const KEY_RE = /^(place|route|post):([a-z0-9-]{1,100})$/;

/** Schlüssel „art:slug“ prüfen; Ungültiges wird verworfen. */
export function parseKeys(list: string[]) {
  const out: { k: BookmarkKind; s: string }[] = [];
  const seen = new Set<string>();
  for (const raw of list) {
    const m = KEY_RE.exec(raw.trim());
    if (!m || seen.has(m[0])) continue;
    seen.add(m[0]);
    out.push({ k: m[1] as BookmarkKind, s: m[2] });
    if (out.length >= MAX_BOOKMARKS) break;
  }
  return out;
}

/** Antwort von /api/merkliste. moved: Einträge, deren Adresse sich geändert hat (alter → neuer Schlüssel). */
export type BookmarkDetails = {
  key: string;
  kind: BookmarkKind;
  slug: string;
  title: string;
  href: string;
  kicker: string;
  text: string;
  media: MediaForPicture | null;
  marker: MapMarker | null;
  track: MapTrack | null;
};
export type BookmarkResponse = { items: BookmarkDetails[]; missing: string[]; moved: Record<string, string> };
